// Chinese Intermediate Vocabulary - 50 unique items
// Each item supports 5 question types: target↔english, target↔pinyin, definition→target

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const chineseIntermediateItems: VocabularyItem[] = [
  // Time & Calendar (1-10)
  {
    id: 'zh-int-001',
    target: '今天',
    english: 'Today',
    romanization: 'jīn tiān',
    definition: 'The present day',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-002',
    target: '明天',
    english: 'Tomorrow',
    romanization: 'míng tiān',
    definition: 'The day after today',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-003',
    target: '昨天',
    english: 'Yesterday',
    romanization: 'zuó tiān',
    definition: 'The day before today',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-004',
    target: '星期',
    english: 'Week',
    romanization: 'xīng qī',
    definition: 'A period of seven days',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-005',
    target: '月',
    english: 'Month / Moon',
    romanization: 'yuè',
    definition: 'A period of about 30 days or the celestial body',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-006',
    target: '年',
    english: 'Year',
    romanization: 'nián',
    definition: 'A period of 12 months',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-007',
    target: '小时',
    english: 'Hour',
    romanization: 'xiǎo shí',
    definition: 'A period of 60 minutes',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-008',
    target: '分钟',
    english: 'Minute',
    romanization: 'fēn zhōng',
    definition: 'A period of 60 seconds',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-009',
    target: '现在',
    english: 'Now',
    romanization: 'xiàn zài',
    definition: 'At the present moment',
    partOfSpeech: 'adverb'
  },
  {
    id: 'zh-int-010',
    target: '以前',
    english: 'Before / Previously',
    romanization: 'yǐ qián',
    definition: 'At an earlier time',
    partOfSpeech: 'adverb'
  },

  // Places & Locations (11-20)
  {
    id: 'zh-int-011',
    target: '学校',
    english: 'School',
    romanization: 'xué xiào',
    definition: 'A place for education and learning',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-012',
    target: '医院',
    english: 'Hospital',
    romanization: 'yī yuàn',
    definition: 'A place for medical treatment',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-013',
    target: '商店',
    english: 'Store / Shop',
    romanization: 'shāng diàn',
    definition: 'A place where goods are sold',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-014',
    target: '饭店',
    english: 'Restaurant / Hotel',
    romanization: 'fàn diàn',
    definition: 'A place to eat or stay overnight',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-015',
    target: '机场',
    english: 'Airport',
    romanization: 'jī chǎng',
    definition: 'A place where airplanes take off and land',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-016',
    target: '火车站',
    english: 'Train station',
    romanization: 'huǒ chē zhàn',
    definition: 'A place where trains stop for passengers',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-017',
    target: '银行',
    english: 'Bank',
    romanization: 'yín háng',
    definition: 'A financial institution for money',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-018',
    target: '公司',
    english: 'Company',
    romanization: 'gōng sī',
    definition: 'A business organization',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-019',
    target: '电影院',
    english: 'Cinema / Movie theater',
    romanization: 'diàn yǐng yuàn',
    definition: 'A place to watch movies',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-020',
    target: '图书馆',
    english: 'Library',
    romanization: 'tú shū guǎn',
    definition: 'A place with books for reading or borrowing',
    partOfSpeech: 'noun'
  },

  // Weather & Nature (21-30)
  {
    id: 'zh-int-021',
    target: '天气',
    english: 'Weather',
    romanization: 'tiān qì',
    definition: 'The atmospheric conditions',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-022',
    target: '热',
    english: 'Hot',
    romanization: 'rè',
    definition: 'Having high temperature',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-int-023',
    target: '冷',
    english: 'Cold',
    romanization: 'lěng',
    definition: 'Having low temperature',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-int-024',
    target: '下雨',
    english: 'To rain',
    romanization: 'xià yǔ',
    definition: 'Water falling from clouds',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-025',
    target: '下雪',
    english: 'To snow',
    romanization: 'xià xuě',
    definition: 'Frozen water falling from clouds',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-026',
    target: '太阳',
    english: 'Sun',
    romanization: 'tài yáng',
    definition: 'The star that gives Earth light and heat',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-027',
    target: '风',
    english: 'Wind',
    romanization: 'fēng',
    definition: 'Moving air',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-028',
    target: '树',
    english: 'Tree',
    romanization: 'shù',
    definition: 'A tall plant with a trunk and branches',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-029',
    target: '花',
    english: 'Flower',
    romanization: 'huā',
    definition: 'The colorful part of a plant',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-030',
    target: '山',
    english: 'Mountain',
    romanization: 'shān',
    definition: 'A large natural elevation of land',
    partOfSpeech: 'noun'
  },

  // Food & Drink (31-40)
  {
    id: 'zh-int-031',
    target: '苹果',
    english: 'Apple',
    romanization: 'píng guǒ',
    definition: 'A round red or green fruit',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-032',
    target: '香蕉',
    english: 'Banana',
    romanization: 'xiāng jiāo',
    definition: 'A long yellow curved fruit',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-033',
    target: '鸡蛋',
    english: 'Egg',
    romanization: 'jī dàn',
    definition: 'An oval object laid by hens',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-034',
    target: '牛奶',
    english: 'Milk',
    romanization: 'niú nǎi',
    definition: 'White liquid from cows',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-035',
    target: '咖啡',
    english: 'Coffee',
    romanization: 'kā fēi',
    definition: 'A dark brown caffeinated drink',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-036',
    target: '面条',
    english: 'Noodles',
    romanization: 'miàn tiáo',
    definition: 'Long thin strips of pasta',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-037',
    target: '蔬菜',
    english: 'Vegetables',
    romanization: 'shū cài',
    definition: 'Plants grown for food',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-038',
    target: '肉',
    english: 'Meat',
    romanization: 'ròu',
    definition: 'Flesh of animals as food',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-039',
    target: '鱼',
    english: 'Fish',
    romanization: 'yú',
    definition: 'An aquatic animal with fins',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-int-040',
    target: '甜',
    english: 'Sweet',
    romanization: 'tián',
    definition: 'Having a taste like sugar',
    partOfSpeech: 'adjective'
  },

  // Common Actions (41-50)
  {
    id: 'zh-int-041',
    target: '工作',
    english: 'To work / Work',
    romanization: 'gōng zuò',
    definition: 'Activity done for employment or purpose',
    partOfSpeech: 'verb/noun'
  },
  {
    id: 'zh-int-042',
    target: '学习',
    english: 'To study / To learn',
    romanization: 'xué xí',
    definition: 'To gain knowledge through effort',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-043',
    target: '睡觉',
    english: 'To sleep',
    romanization: 'shuì jiào',
    definition: 'To rest in an unconscious state',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-044',
    target: '起床',
    english: 'To get up',
    romanization: 'qǐ chuáng',
    definition: 'To rise from bed after sleeping',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-045',
    target: '买',
    english: 'To buy',
    romanization: 'mǎi',
    definition: 'To obtain something by paying money',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-046',
    target: '卖',
    english: 'To sell',
    romanization: 'mài',
    definition: 'To exchange goods for money',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-047',
    target: '打电话',
    english: 'To make a phone call',
    romanization: 'dǎ diàn huà',
    definition: 'To communicate using a telephone',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-048',
    target: '帮助',
    english: 'To help',
    romanization: 'bāng zhù',
    definition: 'To assist or support someone',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-049',
    target: '等',
    english: 'To wait',
    romanization: 'děng',
    definition: 'To stay in place for someone or something',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-int-050',
    target: '问',
    english: 'To ask',
    romanization: 'wèn',
    definition: 'To request information or answers',
    partOfSpeech: 'verb'
  }
];
